import { api } from "./api";

export const blogGenerate = (payload) =>
    api.post(`/blog/generate`, payload).then((r) => r.data);
export const blogGenerateData = (payload) =>
    api.post(`/blog/generate-data`, payload).then((r) => r.data);
export const blogGenerateClub = (payload) =>
    api.post(`/blog/club-opportunities`, payload).then((r) => r.data);

export const blogAdminList = () =>
    api.get(`/blog/admin/posts`).then((r) => r.data);

export const blogAdminGet = (id) =>
    api.get(`/blog/admin/posts/${id}`).then((r) => r.data);

export const blogUpdate = (id, payload) =>
    api.put(`/blog/posts/${id}`, payload).then((r) => r.data);

export const blogDelete = (id) =>
    api.delete(`/blog/posts/${id}`).then((r) => r.data);

export const blogPublicList = () =>
    api.get(`/blog/posts`).then((r) => r.data);

export const blogPublicGet = (slug) =>
    api.get(`/blog/posts/${slug}`).then((r) => r.data);

export const blogShareText = (slug) =>
    api.post(`/blog/posts/${slug}/share-text`, {}, { timeout: 60000 }).then((r) => r.data);

export const blogTranslate = (slug) =>
    api.post(`/blog/posts/${slug}/translate`, {}, { timeout: 120000 }).then((r) => r.data);

export const interviewStart = (payload) =>
    api.post(`/blog/interview/start`, payload, { timeout: 90000 }).then((r) => r.data);
export const interviewReply = (iid, text) =>
    api.post(`/blog/interview/${iid}/reply`, { text }, { timeout: 90000 }).then((r) => r.data);
export const interviewFinish = (iid) =>
    api.post(`/blog/interview/${iid}/finish`).then((r) => r.data);
export const interviewList = () =>
    api.get(`/blog/interview`).then((r) => r.data);
export const blogDailyRun = (date) =>
    api.post(`/blog/daily/run`, { date: date || null }, { timeout: 120000 }).then((r) => r.data);
